import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './TeamProperties.scss';
import { FaTimes } from 'react-icons/fa';
import FormGenerator, { FormFieldConfig } from '../../common/FormGenerator/FormGenerator';
import PopupHeader from '../../common/PopupHeader/PopupHeader';
import '../../common/PopupHeader/PopupHeader.scss';

interface TeamPropertiesProps {
  id?: string;
  onClose: () => void;
  onSave: (team: { id?: string; name: string; description?: string }) => void;
  initialData?: { id?: string; name: string; description?: string };
}

const TeamProperties: React.FC<TeamPropertiesProps> = ({ id, onClose, onSave, initialData }) => {
  const { t } = useTranslation(['common', 'screens']);
  const isEdit = !!id;

  const teamFields: FormFieldConfig[] = useMemo(() => [
    { key: 'name', label: t('screens:teamProperties.fields.teamName'), type: 'string', required: true },
    { key: 'description', label: t('screens:teamProperties.fields.description'), type: 'string' },
  ], [t]);

  const handleSubmit = (data: any) => {
    onSave({ id, name: data.name || '', description: data.description || '' });
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-confirm team-properties-modal" style={{ position: 'relative' }}>
        <button
          type="button"
          className="modal-close-btn"
          aria-label="Close"
          onClick={onClose}
          style={{ position: 'absolute', top: 18, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#888', cursor: 'pointer', zIndex: 2 }}
        >
          <FaTimes />
        </button>
        <PopupHeader>{isEdit ? t('screens:teamProperties.editTeam') : t('screens:teamProperties.createNewTeam')}</PopupHeader>
        <FormGenerator
          fields={teamFields}
          initialData={initialData}
          onSubmit={handleSubmit}
          submitLabel={isEdit ? t('common:save') : t('common:create')}
        />
      </div>
    </div>
  );
};

export default TeamProperties;
